module.exports = __webpack_public_path__ + "static/PoshDS-da0102120e1c116204242df20355c746.png";